var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder-closed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Files-Manager---v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15---Opening-a-folder-",
    transform: "translate(-308.000000, -541.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(245.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row-form-closed_respondents",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-closed",
    transform: "translate(63.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,3 L13.5,3 L10.5,0 L3,0 C1.35075,0 0,1.35075 0,3 L0,9 L30,9 L30,6 C30,4.35075 28.64925,3 27,3",
    id: "Fill-1",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,3 L3,3 C1.35075,3 0,4.35075 0,6 L0,21 C0,22.64925 1.35075,24 3,24 L27,24 C28.64925,24 30,22.64925 30,21 L30,6 C30,4.35075 28.64925,3 27,3",
    id: "Fill-3",
    fill: "#FFCA28"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderClosed);
export default __webpack_public_path__ + "static/media/folder-closed.7b09e1db1ee6e20c44c8a45a3edf7b7a.svg";
export { ForwardRef as ReactComponent };